<label *ngIf="model.Label" for="'FormStaticElement:' + model.Id"> {{ model.Label }} </label>
<p *ngIf="!model.Hidden" 
    [id]="'FormStaticElement:' + model.Id" >
    {{model.Text}}
</p>